import { useToyCollection } from "../src/stores/useToyCollection";

export default function PlayerToyHUD() {
	const collected = useToyCollection((state) => state.collectedCount);
	const total = useToyCollection((state) => state.totalToys);

	return (
		<div
			className="player-toy-hud"
			role="status"
			aria-live="polite"
			aria-label={`Peluches recolectados: ${collected} de ${total}`}
		>
			<div className="player-toy-hud__badge">
				<span className="player-toy-hud__label">Peluches</span>
				<span className="player-toy-hud__count">
					{collected}
					<span className="player-toy-hud__separator">/</span>
					{total}
				</span>
			</div>
		</div>
	);
}
